import { render, staticRenderFns } from "./FormRecipientsTable.vue?vue&type=template&id=5d2580ba&scoped=true&"
import script from "./FormRecipientsTable.vue?vue&type=script&lang=js&"
export * from "./FormRecipientsTable.vue?vue&type=script&lang=js&"
import style0 from "./FormRecipientsTable.vue?vue&type=style&index=0&id=5d2580ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2580ba",
  null
  
)

export default component.exports